import { Dialog } from "primereact/dialog";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getAllRole } from "../../service/role/RoleService";
import { useDispatch, useSelector } from "react-redux";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Password } from "primereact/password";
import {
  createUser,
  deleteUser,
  getAllUsers,
  getUserById,
  updateUser,
} from "../../service/user/userService";
import { CreateUserInputDto } from "../../dtos/user/CreateUserInputDto";
import { UpdateUserInputDto } from "../../dtos/user/UpdateUserInputDto";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faPen,
  faPlus,
  faTrash,
  faUser,
  faLock,
  faEnvelope,
  faPhone,
  faImage,
  faToggleOn
} from "@fortawesome/free-solid-svg-icons";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { TabPanel, TabView } from "primereact/tabview";
import { GetAllRoleDto } from "../../dtos/role/GetAllRoleDto";
import Permission from "../permission/Permission";
import { getPermissionByRole, getPermissionByUserAndRole } from "../../service/permission/permissionService";
import { StatusBadge } from "../ui/StatusBadge";
import { Button } from "../ui/Button";
import { Card } from "../ui/Card";
import { PermissionVariables } from "../../shared/constant/PermissionVariables";
import { Dropdown } from "primereact/dropdown";
import { createSettings } from "../../service/common/commonService";
import { showToast } from '../../store/slices/toastSlice';

export interface IUser {
  name: string;
  surname: string;
  userName: string;
  emailAddress: string;
  password: string;
  phoneNumber: string;
  isActive: boolean;
  profilePicture: string;
  residentStatus: string;
  [key: string]: string | boolean | number;
}

export interface IUserInfo {
  id: number | null;
  tenantId: number | null;
  name: string;
  displayName: string;
  [key: string]: string | (number | null);
}

interface PermissionCheckState {
  [key: string]: {
    checked: boolean;
    partialChecked: boolean;
  };
}

export const User = () => {
  const emptyUser: IUser = {
    name: "",
    surname: "",
    userName: "",
    emailAddress: "",
    password: "",
    phoneNumber: "",
    isActive: true,
    profilePicture: "",
    residentStatus: ""
  };
  const emptyUserInfo: IUserInfo = {
    id: null,
    tenantId: null,
    name: "",
    displayName: "",
  };
  const dispatch = useDispatch();
  const [showCreateUserDialog, setShowCreateUserDialog] =
    useState<boolean>(false);
  const [allUsers, setAllUsers] = useState<CreateUserInputDto[]>([]);
  const [lazyState, setlazyState] = useState({
    page: 1,
    first: 0,
    rows: 5,
    sortField: "id",
    sortOrder: 0 as any,
  });
  const [allRoles, setAllRoles] = useState<GetAllRoleDto[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [usersLength, setUsersLength] = useState<number>(0);
  const [isEditClicked, setIsEditClicked] = useState<boolean>(false);
  const [editUserId, setEditUserId] = useState<number | null>(null);
  const [selectedRole, setSelectedRole] = useState<number | null>(null);
  const [edit, setEdit] = useState<boolean>(false);
  const [permissions, setPermissions] = useState<any[] | []>([]);
  const [originalUser, setOriginalUser] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<number>(0);
  // State for errors
  const [errors, setErrors] = useState<Record<string, string>>({});
  // State for user details
  const [user, setUser] = useState({
    name: "",
    surname: "",
    userName: "",
    emailAddress: "",
    password: "",
    phoneNumber: "",
    isActive: true,
    profilePicture: "",
    residentStatus: ""
  });
  const [userInfo, setUserInfo] = useState(emptyUserInfo);
  const [newlyCreatedUser, setNewlyCreatedUser] = useState()
  const [selectedResidentStatus, setSelectedResidentStatus] = useState<{ name: string, code: string } | null>(null);
  const userPermissions = useSelector(
    (state: any) => state.permission.permissions
  );
  const localization = useSelector((state: any) => state.localization);

  const residentOptions = [
    { name: localization?.Resident || 'Resident', code: 'resident' },
    { name: localization?.NonResident || 'Non-resident', code: 'non_resident' }
  ];
  const [selectedKeys, setSelectedKeys] = useState<PermissionCheckState | {}>(
    {}
  );

  const toast = useRef<Toast>(null);
  const [isSaveClicked, setIsSaveClicked] = useState<boolean>(false);
  const [isCreateClicked, setIsCreateClicked] = useState<boolean>(false);

  const hideCreateEditUserDialog = () => {
    setPermissions([])
    setErrors({})
    setIsCreateClicked(false);
    setShowCreateUserDialog(false);
    setUser(emptyUser);
    setEditUserId(null);
    setEdit(false);
    setIsEditClicked(false);
    setAllRoles([]);
    setSelectedRole(null);
    setIsSaveClicked(false);
    setActiveTab(0);
    setSelectedKeys({})
    setUserInfo(emptyUserInfo)
  };

  const getAllRolesData = async () => {
    const roles = await getAllRole(dispatch);
    setAllRoles(roles);
  };

  const accept = async (id: number) => {
    await onDelete(id);
    dispatch(showToast({
      severity: 'success',
      summary: localization?.Success || 'Success',
      detail: localization?.UserDeletedSuccessfully || 'User deleted successfully',
      life: 3000
    }));
  };

  const reject = () => {
    dispatch(showToast({
      severity: 'warn',
      summary: localization?.Rejected || 'Rejected',
      detail: localization?.YouHaveRejected || 'You have rejected',
      life: 3000
    }));
  };

  const allDataFunc = async () => {
    let param;

    if (searchText?.length > 0) {
      param = {
        Limit: lazyState.rows,
        Page: lazyState.page,
        SortBy: lazyState.sortOrder === 1 ? "ASC" : "DESC",
        SortProperty: lazyState.sortField,
        Filter: searchText,
        PropertyNames: ["Name"],
      };
    } else {
      param = {
        Limit: lazyState.rows,
        Page: lazyState.page,
        SortBy:
          lazyState.sortOrder === 1
            ? "ASC"
            : lazyState.sortOrder === -1
              ? "ASC"
              : "DESC",
        SortProperty: lazyState.sortField ?? "id",
      };
    }

    const res: any = await getAllUsers(dispatch, param);
    setAllUsers(res?.List);
    setUsersLength(res?.TotalCount);
  };

  const handleEditClick = async (rowData: UpdateUserInputDto) => {
    const inputId = { id: rowData.id };
    const userToEditInfo = await getUserById(dispatch, inputId);
    setIsEditClicked(true);
    setEdit(true);
    setSelectedRole(userToEditInfo?.Roles[0]?.id);
    setShowCreateUserDialog(true);
    setUser(userToEditInfo);
    setEditUserId(rowData.id);
    setUserInfo({
      id: userToEditInfo?.id,
      tenantId: userToEditInfo?.tenantId,
      name: userToEditInfo?.name,
      displayName: userToEditInfo?.displayName,
    });

  };

  const openNew = () => {
    setUser(emptyUser);
    setShowCreateUserDialog(true);
  };

  const onDelete = async (id: number) => {
    await deleteUser(dispatch, id);
    await allDataFunc();
  };

  const onPageChange = (event: any) => {
    setlazyState({ ...event, page: event.page + 1 });
  };

  const onSave = async () => {
    const input: CreateUserInputDto = {
      ...user,
      roleIds: [selectedRole as number],
    };
    const createdUser = await createUser(dispatch, input);
    setUserInfo(createdUser?.user);
    // setNewlyCreatedUser(createdUser.user)
    dispatch(showToast({
      severity: 'success',
      summary: localization?.Success || 'Success',
      detail: localization?.UserCreatedSuccessfully || `User created successfully`,
      life: 3000
    }));
  };

  const onEditHandler = async () => {
    if (editUserId && user) {
      const input: UpdateUserInputDto = {
        ...user,
        id: editUserId,
        roleIds: [selectedRole as number],
        profilePicture: user.profilePicture || "",
      };
      // Check if the user data has actually changed
      const isChanged = JSON.stringify(originalUser) !== JSON.stringify(input);

      if (!isChanged) {
        return;
      }
      await updateUser(dispatch, editUserId, input);
    }
    dispatch(showToast({
      severity: 'success',
      summary: localization?.Success || 'Success',
      detail: localization?.UserUpdatedSuccessfully || `User updated successfully`,
      life: 3000
    }));
  };

  const handleTabChange = (e: any) => {
    setActiveTab(e.index);
  };

  // Handle form submission
  const handleSave = async () => {
    // Check for missing fields
    const requiredFields = [
      "name",
      "surname",
      "userName",
      "emailAddress",
      "phoneNumber",
    ];
    // If it's not an edit operation, add 'password' to the required fields
    if (!isEditClicked) {
      requiredFields.push("password");
    }
    let newErrors: Record<string, string> = {};

    for (const field of requiredFields) {
      if (!user[field as keyof typeof user]?.toString().trim()) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
      }
    }

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // Email format validation – only if it’s not already missing
    if (user.emailAddress?.toString().trim() && !emailRegex.test(user.emailAddress)) {
      newErrors.emailAddress = "Invalid email address format.";
    }

    // Phone number format validation (adjust regex as needed)
    const phoneRegex = /^[0-9]{10}$/;
    // Phone number format validation – only if it’s not already missing
    if (user.phoneNumber?.toString().trim() && !phoneRegex.test(user.phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be 10 digits.";
    }

    // Password strength validation (only when creating a new user)
    if (!isEditClicked && user.password?.toString().trim()) {
      const password = user.password.toString().trim();
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

      if (!passwordRegex.test(password)) {
        newErrors.password = "Password must be at least 8 characters and include uppercase, lowercase, number, and special character.";
      }
    }

    if (Object.keys(newErrors)?.length > 0) {
      setErrors(newErrors);
      dispatch(showToast({
        severity: 'error',
        summary: localization?.Error || 'Error',
        detail: localization?.PleaseFillinAllRequiredFields || `Please fill all the required fields.`,
        life: 3000
      }));
      return;
    }

    if (!selectedRole) {
      dispatch(showToast({
        severity: 'error',
        summary: localization?.Error || 'Error',
        detail: localization?.PleaseSelectRoleToProceed || `Please select any role to proceed`,
        life: 3000
      }));
      return;
    }

    if (isEditClicked) {
      await onEditHandler();
    } else {
      // If all validations pass, proceed to save
      await onSave();
    }
    setIsSaveClicked(true);
    await allDataFunc();
    hideCreateEditUserDialog();
  };

  const getRolePermissions = async () => {
    
    if (selectedRole) {
      const permission = await getPermissionByRole(dispatch, {
        roleId: selectedRole,
        tenantId: userInfo?.tenantId
      });
      setPermissions(permission.permissions);
    }

  }
  const getAllPermissions= async () => {
    if(isEditClicked){
    if (userInfo?.id && selectedRole) {
      const permission = await getPermissionByUserAndRole(dispatch, {
        userId: userInfo?.id,
        tenantId: userInfo?.tenantId,
        roleIds: [selectedRole],
      });
      const grantedPermissions = permission?.map((permission: any) => {
        return {
          isGranted: true,
          name: permission,
        };
      });
      setPermissions(grantedPermissions);
    }
  }else{
    getRolePermissions()
  }

  }
  // Handle text input changes
  const onInputChange = (e: any, fieldName: string) => {
    setUser({ ...user, [fieldName]: e.target.value });

    // Clear error for this field when user starts typing
    if (errors[fieldName]) {
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    }
  };

  // Handle file selection and convert image to Base64
  const onFileChange = (e: any) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setUser((prevUser: any) => ({
          ...prevUser,
          profilePicture: event?.target?.result || "",
        }));
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  // Using our custom StatusBadge instead of PrimeReact Tag
  const activeBodyTemplate = (rowData: any) => {
    return (
      <StatusBadge
        status={rowData.isActive ? "active" : "cancelled"}
        className="text-xs font-medium"
      />
    );
  };

  const confirm = (id: number) => {
    confirmDialog({
      message: (
        <div className="text-center p-4">
          <p className="mb-4 text-base font-medium text-charcoal">
            {localization?.DoYouReallyWantToDeleteUser || "Do you really want to delete this"} <strong>{localization?.User || "user"}</strong>?
          </p>
        </div>
      ),
      header: localization?.DeleteConfirmation || `Delete Confirmation`,
      className: "rounded-lg shadow-lg",
      acceptClassName: "p-button-danger",
      accept: () => accept(id),
      reject,
    });
  };

  const startToolbar = () => {
    return (
      <div className="text-xl font-semibold text-charcoal">
        <h1 className="text-xl font-bold surface-900 mb-4">{localization?.Users || "Users"}</h1>
      </div>
    );
  };

  const endToolbar = () => {
    return (
      <div>
        {userPermissions?.includes(PermissionVariables.createUser) && (
          <Button
            variant="primary"
            onClick={openNew}
            className="h-10 px-4 text-sm font-medium bg-gold text-white hover:opacity-90 transition-all"
          >
            {localization?.Create || "Create"}
          </Button>
        )}
      </div>
    );
  };

  const actionBodyTemplate = (rowData: UpdateUserInputDto) => {
    return (
      <div className="flex space-x-2">
        {userPermissions?.includes(PermissionVariables.editUser) && (
          <Button
            variant="secondary"
            className="actionBtn h-8 w-8 p-0 flex items-center bg-transparent hover:bg-gold justify-center border-gold text-gold hover:text-white transition-all"
            onClick={() => handleEditClick(rowData)}
          >
            <FontAwesomeIcon icon={faPen} className="text-sm" />
          </Button>
        )}
        {userPermissions?.includes(PermissionVariables.deleteUser) && (
          <Button
            variant="danger"
            className="actionBtn h-8 w-8 p-0 flex items-center justify-center bg-transparent hover:bg-red-500 border-alert-red text-alert-red hover:text-white transition-all"
            onClick={() => confirm(rowData.id as number)}
          >
            <FontAwesomeIcon icon={faTrash} className="text-sm" />
          </Button>
        )}
      </div>
    );
  };

  const createRoleDialogFooter = () => {
    return (
      <div className="flex justify-end space-x-4">
        <Button
          variant="primary"
          onClick={handleSave}
          className="h-10 px-4 text-sm font-medium bg-gold text-white hover:opacity-90 transition-all"
        >
          {localization?.Save || "Save"}
        </Button>
        <Button
          variant="secondary"
          onClick={hideCreateEditUserDialog}
          className="h-10 px-4 text-sm font-medium bg-white border-gold text-gold hover:text-white hover:bg-gold hover:bg-opacity-10 transition-all"
        >
          {localization?.Cancel || "Cancel"}
        </Button>
      </div>
    );
  };

  useEffect(() => {
    if (editUserId && user) {
      setOriginalUser({ ...user, roleIds: [selectedRole] }); // Store the initial user state
    }
  }, [editUserId]);

  useEffect(() => {
    getAllPermissions()
  }, [selectedRole, userInfo])
console.log(selectedRole)
  useEffect(() => {
    allDataFunc();
  }, [lazyState]);

  useEffect(() => {
    if (showCreateUserDialog) {
      getAllRolesData();
    }
  }, [showCreateUserDialog]);

  return (
    <div className="block p-0">
      <ConfirmDialog className="rounded-lg shadow-lg" />
      <Toolbar
        start={startToolbar}
        end={endToolbar}
        className="mb-0 border-0 bg-transparent p-0"
      />
      <Toast ref={toast} className="rounded-lg shadow-lg" />

      {/* DataTable wrapped in Card component */}
      <Card className="mb-8 overflow-hidden bg-white shadow-sm border border-light-gray card_content_padding">
        <DataTable
          value={allUsers}
          dataKey="id"
          lazy
          paginator
          first={lazyState.first}
          rows={lazyState.rows}
          totalRecords={usersLength}
          onPage={onPageChange}
          rowsPerPageOptions={[5, 10, 15, 20]}
          currentPageReportTemplate={localization?.TotalRecords || "Total Records {totalRecords} "}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          className="p-datatable-sm"
          emptyMessage={localization?.NoUsersFound || "No users found"}
          rowHover
        >
          <Column
            field="name"
            header={localization?.Name || "Name"}
            className="p-4 text-sm text-charcoal"
            headerClassName="bg-cream text-charcoal font-medium"
          ></Column>
          <Column
            field="surname"
            header={localization?.Surname || "Surname"}
            className="p-4 text-sm text-charcoal"
            headerClassName="bg-cream text-charcoal font-medium"
          ></Column>
          <Column
            field="userName"
            header={localization?.UserName || "User Name"}
            className="p-4 text-sm text-charcoal"
            headerClassName="bg-cream text-charcoal font-medium"
          ></Column>
          <Column
            field="emailAddress"
            header={localization?.EmailAddress || "Email Address"}
            className="p-4 text-sm text-charcoal"
            headerClassName="bg-cream text-charcoal font-medium"
          ></Column>
          <Column
            field="phoneNumber"
            header={localization?.PhoneNumber || "Phone Number"}
            className="p-4 text-sm text-charcoal"
            headerClassName="bg-cream text-charcoal font-medium"
          ></Column>
          <Column
            field="isActive"
            header={localization?.Status || "Status"}
            body={activeBodyTemplate}
            className="p-4 text-sm"
            headerClassName="bg-cream text-charcoal font-medium"
          ></Column>
          {(userPermissions?.includes(PermissionVariables.editUser) ||
            userPermissions?.includes(PermissionVariables.deleteUser)) && (
              <Column
                header={localization?.Actions || "Actions"}
                body={actionBodyTemplate}
                className="p-4 text-sm"
                headerClassName="bg-cream text-charcoal font-medium"
              ></Column>
            )}
        </DataTable>
      </Card>

      <Dialog
        visible={showCreateUserDialog}
        header={isEditClicked ? (localization?.EditUser || "Edit User") : (localization?.CreateUser || "Create User")}
        onHide={hideCreateEditUserDialog}
        footer={createRoleDialogFooter}
        className="rounded-lg shadow-xl border border-light-gray"
        contentClassName="bg-white p-0"
        headerClassName="bg-charcoal py-4 px-6 text-white font-semibold"
        style={{ width: "50rem", maxWidth: "95vw" }}
        breakpoints={{ "960px": "90vw", "641px": "95vw" }}
      >
        <TabView
          activeIndex={activeTab}
          onTabChange={(e) => handleTabChange(e)}
          renderActiveOnly={false}
          className="border-none tabPadding_0"
          pt={{
            nav: { className: 'p-0' },
            inkbar: { className: 'bg-gold' },
            navContainer: { className: 'px-0' }
          }}
        >
          <TabPanel
            header={localization?.UserDetails || "User Details"}
            headerClassName={`${activeTab === 0 ? 'text-gold font-medium' : 'text-medium-gray'}p-0 pt-3`}
            className="p-0"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Name */}
              <div className="mb-0">
                <label className="block text-sm font-medium text-charcoal mb-2">
                  <FontAwesomeIcon icon={faUser} className="mr-2 text-gold" />
                  {localization?.Name || "Name"} <span className="text-alert-red">*</span>
                </label>
                <InputText
                  type="text"
                  value={user.name}
                  onChange={(e) => onInputChange(e, "name")}
                  className={`w-full h-10 rounded-md ${errors.name ? "border-alert-red" : "border-light-gray"
                    } focus:border-gold focus:ring focus:ring-gold focus:ring-opacity-50`}
                  placeholder={localization?.EnterFirstName || "Enter first name"}
                />
                {errors.name && (
                  <small className="text-alert-red text-xs mt-1 block">{errors.name}</small>
                )}
              </div>

              {/* Surname */}
              <div className="mb-0">
                <label className="block text-sm font-medium text-charcoal mb-2">
                  <FontAwesomeIcon icon={faUser} className="mr-2 text-gold" />
                  {localization?.Surname || "Surname"} <span className="text-alert-red">*</span>
                </label>
                <InputText
                  type="text"
                  value={user.surname}
                  onChange={(e) => onInputChange(e, "surname")}
                  className={`w-full h-10 rounded-md ${errors.surname ? "border-alert-red" : "border-light-gray"
                    } focus:border-gold focus:ring focus:ring-gold focus:ring-opacity-50`}
                  placeholder={localization?.EnterLastName || "Enter last name"}
                />
                {errors.surname && (
                  <small className="text-alert-red text-xs mt-1 block">{errors.surname}</small>
                )}
              </div>

              {/* Username */}
              <div className="mb-0">
                <label className="block text-sm font-medium text-charcoal mb-2">
                  <FontAwesomeIcon icon={faUser} className="mr-2 text-gold" />
                  {localization?.Username || "Username"} <span className="text-alert-red">*</span>
                </label>
                <InputText
                  type="text"
                  value={user.userName}
                  onChange={(e) => onInputChange(e, "userName")}
                  className={`w-full h-10 rounded-md ${errors.userName ? "border-alert-red" : "border-light-gray"
                    } focus:border-gold focus:ring focus:ring-gold focus:ring-opacity-50`}
                  placeholder={localization?.EnterUsername || "Enter username"}
                />
                {errors.userName && (
                  <small className="text-alert-red text-xs mt-1 block">{errors.userName}</small>
                )}
              </div>

              {/* Email Address */}
              <div className="mb-0">
                <label className="block text-sm font-medium text-charcoal mb-2">
                  <FontAwesomeIcon icon={faEnvelope} className="mr-2 text-gold" />
                  {localization?.EmailAddress || "Email Address"} <span className="text-alert-red">*</span>
                </label>
                <InputText
                  type="email"
                  value={user.emailAddress}
                  onChange={(e) => onInputChange(e, "emailAddress")}
                  className={`w-full h-10 rounded-md ${errors.emailAddress ? "border-alert-red" : "border-light-gray"
                    } focus:border-gold focus:ring focus:ring-gold focus:ring-opacity-50`}
                  placeholder={localization?.EnterEmailAddress || "Enter email address"}
                />
                {errors.emailAddress && (
                  <small className="text-alert-red text-xs mt-1 block">{errors.emailAddress}</small>
                )}
              </div>

              {/* Password - only visible when creating new user */}
              {!edit && (
                <div className="mb-0">
                  <label className="block text-sm font-medium text-charcoal mb-2">
                    <FontAwesomeIcon icon={faLock} className="mr-2 text-gold" />
                    {localization?.Password || "Password"} <span className="text-alert-red">*</span>
                  </label>
                  <Password
                    value={user.password}
                    onChange={(e) => onInputChange(e, "password")}
                    feedback={false}
                    toggleMask
                    className={`w-full full_icon_field ${errors.password ? "p-invalid" : ""
                      }`}
                    inputClassName={`w-full h-10 rounded-md ${errors.password ? "border-alert-red" : "border-light-gray"
                      } focus:border-gold focus:ring focus:ring-gold focus:ring-opacity-50`}
                    placeholder={localization?.EnterPassword || "Enter password"}
                    pt={{
                      hideIcon: { className: "text-medium-gray" },
                      showIcon: { className: "text-medium-gray" }
                    }}
                  />
                  {errors.password && (
                    <small className="text-alert-red text-xs mt-1 block">{errors.password}</small>
                  )}
                </div>
              )}

              {/* Phone Number */}
              <div className="mb-0">
                <label className="block text-sm font-medium text-charcoal mb-2">
                  <FontAwesomeIcon icon={faPhone} className="mr-2 text-gold" />
                  {localization?.PhoneNumber || "Phone Number"} <span className="text-alert-red">*</span>
                </label>
                <InputText
                  type="tel"
                  value={user.phoneNumber}
                  onChange={(e) => onInputChange(e, "phoneNumber")}
                  className={`w-full h-10 rounded-md ${errors.phoneNumber ? "border-alert-red" : "border-light-gray"
                    } focus:border-gold focus:ring focus:ring-gold focus:ring-opacity-50`}
                  placeholder={localization?.EnterPhoneNumber || "Enter phone number"}
                />
                {errors.phoneNumber && (
                  <small className="text-alert-red text-xs mt-1 block">{errors.phoneNumber}</small>
                )}
              </div>
              {/* Resident Status */}
              <div className="mb-0">
                <label className="block text-sm font-medium text-charcoal mb-2">
                  <FontAwesomeIcon icon={faPhone} className="mr-2 text-gold" />
                  {localization?.ResidentStatus || "Resident Status"} <span className="text-alert-red">*</span>
                </label>
                <Dropdown
                  value={user.residentStatus}
                  onChange={(e: any) => {
                    onInputChange(e, "residentStatus")
                  }} options={residentOptions} optionLabel="name"
                  placeholder={localization?.SelectAResidentOption || "Select a resident option"} className="w-full md:w-14rem" />
                {errors.residentStatus && (
                  <small className="text-alert-red text-xs mt-1 block">{errors.residentStatus}</small>
                )}
              </div>

              {/* Status (Active/Inactive) */}
              <div className="mb-0">
                <label className="block text-sm font-medium text-charcoal mb-2">
                  <FontAwesomeIcon icon={faToggleOn} className="mr-2 text-gold" />
                  {localization?.Status || "Status"}
                </label>
                <div className="flex items-center space-x-3">
                  <Button
                    variant={user.isActive ? "primary" : "secondary"}
                    onClick={() => setUser({ ...user, isActive: true })}
                    className={`w-24 h-10 px-4 text-sm font-medium flex items-center justify-center ${user.isActive
                      ? " bg-success-green border-green-500 text-white1"
                      : "activebtn bg-white border-light-gray text-medium-gray "
                      }`}
                    type="button"
                  >
                    <FontAwesomeIcon icon={faCheck} className="mr-2" />
                    {localization?.Active || "Active"}
                  </Button>
                  <Button
                    variant={!user.isActive ? "danger" : "secondary"}
                    onClick={() => setUser({ ...user, isActive: false })}
                    className={`w-24 h-10 px-4 text-sm font-medium flex items-center justify-center ${!user.isActive
                      ? " bg-alert-red text-white "
                      : "activebtn bg-white border-light-gray text-medium-gray"
                      }`}
                    type="button"
                  >
                    <FontAwesomeIcon icon={faToggleOn} className="mr-2" />
                    {localization?.Inactive || "Inactive"}
                  </Button>
                </div>
              </div>

              {/* Profile Picture */}
              <div className="mb-0 col-span-1 md:col-span-2">
                <label className="block text-sm font-medium text-charcoal mb-2">
                  <FontAwesomeIcon icon={faImage} className="mr-2 text-gold" />
                  {localization?.ProfilePicture || "Profile Picture"}
                </label>
                <div className="flex items-center gap-4">
                  {user.profilePicture ? (
                    <div className="w-16 h-16 rounded-full overflow-hidden border border-light-gray shadow-sm">
                      <img
                        src={user.profilePicture}
                        alt="Profile"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ) : (
                    <div className="w-16 h-16 rounded-full flex items-center justify-center bg-cream border border-light-gray text-medium-gray">
                      <FontAwesomeIcon icon={faUser} className="text-xl" />
                    </div>
                  )}
                  <div className="flex-1">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={onFileChange}
                      className="p-2 w-full border border-light-gray rounded-md focus:border-gold focus:ring focus:ring-gold focus:ring-opacity-50"
                    />
                    <small className="text-medium-gray mt-1 block text-xs">{localization?.UploadProfilePictureOptional || "Upload a profile picture (optional)"}</small>
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel
            header={localization?.UserRoles || "User Roles"}
            headerClassName={`${activeTab === 1 ? 'text-gold font-medium' : 'text-medium-gray'} p-0 pt-3`}
            className="p-0"
          >
            <div className="mb-4">
              <p className="text-sm text-medium-gray mb-4 mt-0">{localization?.SelectRoleForUser || "Select a role for this user. The role determines what permissions the user will have."}</p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {allRoles?.map((role) => (
                  <div
                    key={role.id}
                    className={`role-option-card flex items-center p-4 border rounded-lg transition-colors cursor-pointer bg-gray-50 ${selectedRole === role.id
                      ? "border-gold bg-cream shadow-sm"
                      : "border-light-gray hover:border-gold hover:bg-cream"
                      }`}
                    onClick={() => setSelectedRole(role.id as number)}
                  >
                    <div className="flex items-center">
                      <div
                        className={`w-5 h-5 flex items-center bg-white shadow justify-center rounded ${selectedRole === role.id
                          ? "bg-gold text-white"
                          : "border border-medium-gray"
                          }`}
                      >
                        {selectedRole === role.id && <FontAwesomeIcon icon={faCheck} className="text-xs" />}
                      </div>
                      <label className="ml-3 text-sm font-medium text-charcoal cursor-pointer">
                        {role.displayName}
                      </label>
                    </div>
                  </div>
                ))}
              </div>

              {!selectedRole && (
                <p className="text-gold text-sm font-medium mt-4">
                  <FontAwesomeIcon icon={faCheck} className="mr-2" />
                  {localization?.PleaseSelectRoleForUser || "Please select a role for this user"}
                </p>
              )}
            </div>
          </TabPanel>
          <TabPanel
            header={localization?.UserPermissions || "User Permissions"}
            headerClassName={`${activeTab === 2 ? 'text-gold font-medium' : 'text-medium-gray'}p-0 pt-3`}
            className="p-0"
          >
            {
              <Permission
                selectedKeys={selectedKeys}
                setSelectedKeys={setSelectedKeys}
                componentInfo={"User"}
                allPermissions={permissions}
                resetDialog={hideCreateEditUserDialog}
                roleInfo={userInfo}
                isSaveClicked={isSaveClicked}
              />
            }
          </TabPanel>
        </TabView>
      </Dialog>
    </div>
  );
};